import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {LocalisationService} from './localisation.service';

@Injectable()
export class NotificationsService {
    timeout = 6500;

    constructor(
        private readonly toastrService: ToastrService,
        private readonly localisationService: LocalisationService
    ) {
    }

    success(message: string) {
        this.toastrService.success(message, this.localisationService.localise('success'), {
            progressBar: true,
            closeButton: true,
            positionClass: 'toast-top-center',
            timeOut: this.timeout
        });
    }

    info(message: string) {
        this.toastrService.info(message, this.localisationService.localise('information'), {
            progressBar: true,
            closeButton: true,
            positionClass: 'toast-top-center',
            timeOut: this.timeout
        });
    }

    warning(message: string) {
        this.toastrService.warning(message, this.localisationService.localise('warning'), {
            progressBar: true,
            closeButton: true,
            positionClass: 'toast-top-center',
            timeOut: this.timeout
        });
    }

    error(message: string) {
        this.toastrService.error(message, this.localisationService.localise('error'), {
            progressBar: true,
            closeButton: true,
            positionClass: 'toast-top-center',
            timeOut: this.timeout
        });
    }
}
